import React from 'react';
import './Spinner.css';

// Map named sizes to pixel values
const NAMED_SIZES = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 40,
  xl: 56,
};

const Spinner = ({ label = 'Loading...', full = false, size = 'lg', className = '' }) => {
  const containerStyle = full ? { minHeight: 140 } : {};

  // Normalize size: allow numbers (pixels) or named strings
  const numericSize = typeof size === 'number' ? size : (NAMED_SIZES[size] || NAMED_SIZES.lg);

  // Border width scales with size but has sensible bounds
  const borderWidth = Math.max(2, Math.min(Math.round(numericSize / 8), 6));

  const spinnerStyle = {
    // Expose CSS variables used by Spinner.css
    ['--spinner-size']: `${numericSize}px`,
    ['--spinner-border']: `${borderWidth}px`,
  };

  return (
    <div className={`spinner-container ${full ? 'spinner-stack' : ''} ${className}`} style={containerStyle}>
      <div className="spinner" style={spinnerStyle} />
      {label && full && <div className="spinner-label">{label}</div>}
    </div>
  );
};

export default Spinner;

